import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ReportsSectionThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function ReportsSectionThumbnail({ 
  isHovered = false, 
  alwaysVisible = false 
}: ReportsSectionThumbnailProps) {
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const hoverScale = isHovered ? 'scale-100' : baseScale;

  return (
    <div className={`transition-transform duration-300 origin-left ${hoverScale} ${isHovered ? 'z-50' : ''}`}>
      <Card className="w-[300px] shadow-sm">
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between">
            <CardTitle className="text-sm font-medium">Reports</CardTitle>
            <FileText className="h-4 w-4 text-muted-foreground" />
          </div>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            <div className="flex items-center justify-between p-2 rounded bg-muted/50">
              <div className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-blue-500" />
                <div>
                  <div className="text-sm font-medium">Cash Flow Statement</div>
                  <div className="text-xs text-muted-foreground">Monthly summary</div>
                </div>
              </div>
              <Button size="sm" variant="ghost" className="h-7 w-7 p-0">
                <Download className="h-3 w-3" />
              </Button>
            </div>
            <div className="flex items-center justify-between p-2 rounded bg-muted/50">
              <div className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-green-500" />
                <div>
                  <div className="text-sm font-medium">Forecast Accuracy</div>
                  <div className="text-xs text-muted-foreground">Variance analysis</div>
                </div>
              </div>
              <Button size="sm" variant="ghost" className="h-7 w-7 p-0">
                <Download className="h-3 w-3" />
              </Button>
            </div>
            <div className="flex items-center justify-between p-2 rounded bg-muted/50">
              <div className="flex items-center gap-2">
                <FileText className="h-4 w-4 text-purple-500" />
                <div>
                  <div className="text-sm font-medium">Board Report</div>
                  <div className="text-xs text-muted-foreground">Executive summary</div>
                </div>
              </div>
              <Button size="sm" variant="ghost" className="h-7 w-7 p-0">
                <Download className="h-3 w-3" />
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
